import { render, staticRenderFns } from "./CompletionDate.vue?vue&type=template&id=2315cb72"
import script from "./CompletionDate.vue?vue&type=script&lang=js"
export * from "./CompletionDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports